import { sendEvent } from './send-event';

export const sendViewEvent = (label: string) => {
    return sendEvent('view', { label });
};

export const sendClickEvent = (label: string) => {
    return sendEvent('click', { label, client_timestamp: new Date().toISOString() });
};

export const sendTimeDeltaEvent = (label: string, startTime: number, endTime: number) => {
    return sendEvent('time_delta', {
        label,
        start_time: new Date(startTime).toISOString(),
        end_time: new Date(endTime).toISOString(),
        time_delta: endTime - startTime
    });
};
